/**
 * QuizButton - Button styled to match quiz pages
 */

import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

interface QuizButtonProps extends Omit<ButtonProps, "variant"> {
  variant?: "primary" | "secondary" | "outlined";
}

export function QuizButton({
  variant = "primary",
  children,
  sx,
  ...props
}: QuizButtonProps) {
  const variantStyles = {
    primary: {
      background: QUIZ.color.brown,
      color: QUIZ.color.white,
      fontFamily: QUIZ.font.button,
      fontWeight: 700,
      borderRadius: QUIZ.radius.pill,
      textTransform: "none" as const,
      padding: { xs: "10px 18px", sm: "9px 20px" },
      minWidth: { xs: 120, sm: 140, md: 160 },
      fontSize: { xs: 14, sm: 15, md: 16 },
      "&:hover": {
        background: QUIZ.color.ink,
      },
      "&:disabled": {
        background: "#b8a6a4",
        color: QUIZ.color.white,
      },
    },
    secondary: {
      borderColor: QUIZ.color.brown,
      borderWidth: "2px",
      borderRadius: QUIZ.radius.pill,
      backgroundColor: QUIZ.color.warmWhite,
      color: QUIZ.color.brown,
      fontFamily: QUIZ.font.button,
      fontWeight: 700,
      textTransform: "none" as const,
      padding: { xs: "10px 18px", sm: "9px 20px" },
      fontSize: { xs: 14, sm: 15, md: 16 },
      "&:hover": {
        background: "rgba(255,252,245,0.92)",
        borderWidth: "2px",
      },
    },
    outlined: {
      borderColor: QUIZ.color.white,
      borderWidth: "2px",
      borderRadius: QUIZ.radius.pill,
      backgroundColor: "transparent",
      color: QUIZ.color.white,
      fontFamily: QUIZ.font.button,
      fontWeight: 700,
      textTransform: "none" as const,
      padding: { xs: "10px 18px", sm: "9px 20px" },
      fontSize: { xs: 14, sm: 15, md: 16 },
      "&:hover": {
        background: "rgba(255,255,255,0.1)",
        borderWidth: "2px",
      },
    },
  };

  return (
    <Button sx={{ ...variantStyles[variant], ...sx }} {...props}>
      {children}
    </Button>
  );
}
